import { createApp } from 'vue';
import { formatDayOfMonthByLocale, formatDateByLocale } from '../yfantis.js';
jQuery(function($) {


    // shortcode birthdaylist
    if ($("#YF-content-birthdaylist").length === 1) {
        createApp({
            data: () => ({
                members: []
            }),
            mounted() {
                this.getBirthdays();
            },
            methods: {
                formatDayOfMonthByLocale,
                getBirthdays() {
                    this.members = membersAsJson;
                }
            }
        }).mount("#YF-content-birthdaylist");
    }

    // shortcode memberpresentation
    if ($("#YF-content-memberpresentation").length === 1) {
        createApp({
            data: () => ({
                members: [],
                yfantisUrl: ''
            }),
            mounted() {
                this.yfantisUrl = yfantisUrl;
                this.getMembersInFunction();
            },
            methods: {
                getMembersInFunction() {

                    this.members = membersAsJson;
                    this.members.forEach(member => {
                        // try the url. if it gives a 404, set the anonymous image
                        // give it a second to load though
                        var img = new Image();
                        img.src = this.yfantisUrl + `app/public/members/${member.photo}`;
                        setTimeout(() => {
                            console.log(`height: ${img.height}`);
                            if (img.height > 0) {
                                member.photo = this.yfantisUrl + `app/public/members/${member.photo}`
                            } else {
                                member.photo = this.yfantisUrl + `app/public/members/anonymous.jpg`;
                            }
                        }, 1000);
                    })
                }
            }
        }).mount("#YF-content-memberpresentation");
    }

    if ($("#YF-content-members-infolist").length === 1) {
        console.log(`member info component`);
        createApp({
            data: () => ({
                currentMembers: [],
                prevMembers: []
            }),
            mounted() {
                this.getMembersInfo();
            },
            methods: {
                formatDateByLocale,
                getMembersInfo() {
                    this.currentMembers = membersAsJson.currentMembers;
                    this.prevMembers = membersAsJson.prevMembers;
                }
            }
        }).mount("#YF-content-members-infolist");
    }

    if ($("#YF-content-memberresetpw").length === 1) {
        console.log(`members reset pw`);
        createApp({
            data: () => ({
                memberemail: ''
            }),
            mounted() {
                // check if we have an emailaddress as get parameter
                let email = findGetParameter("email");
                if(email !== null) {
                    this.memberemail = email;
                }
            },
            computed: {
                validEmail() {
                    const hasDot = this.memberemail.indexOf('.') !== -1;
                    const hasAtSign = this.memberemail.indexOf('@') !== -1;
                    const has6chars = this.memberemail.length > 5;
                    const hasMorethanOneCharAfterLastDot = this.memberemail.lastIndexOf(".") < (this.memberemail.length - 2);
                    return hasDot && hasAtSign && has6chars && hasMorethanOneCharAfterLastDot;
                }
            }
        }).mount("#YF-content-memberresetpw");
    }

    if ($("#YF-content-memberlogin").length === 1) {
        console.log(`member login component`);
        createApp({
            data: () => ({
                currentpageurl: '',
                enteredemail: ''
            }),
            mounted() {
                this.getCurrentPageUrl();
            },
            methods: {
                getCurrentPageUrl() {
                    this.currentpageurl = window.location.href;
                }
            },
            computed: {
                currentpageurlresetpw() {
                    let result = '';
                    // if contains ? use &
                    result = (this.currentpageurl.indexOf("?") === -1) ?
                        this.currentpageurl + "?action=resetmypw" :
                        this.currentpageurl + "&action=resetmypw";
                    if(this.enteredemail.length > 0) {
                        result += `&email=${this.enteredemail}`;
                    }
                    return result;
                }
            }
        }).mount("#YF-content-memberlogin");
    }

/*    if ($("#YF-content-memberprofile").length === 1) {
        new Vue({
            el: "#YF-content-memberprofile",
            data: {
                messagedate: '',
                saveMessageOK: '',      // message from the backend after clicking "save"
                saveMessageFail: '',    // message from the backend after clicking "save"
                memberRecord: {
                    birth_day: '',
                    birth_month: '',
                    birth_year: ''
                }
            },
            mounted() {
                console.log(`profile page mounted`);
                //this.getMemberRecord();
                //this.getSaveMessages();
                // Remove saveMessagesOK after some seconds
                // Fail message stays on screen
                setTimeout(() => {
                    this.saveMessageOK = '';
                }, 3000);
            },
            methods: {
                getMemberRecord() {
                    // membersAsJson variable added by the wordpress backend
                    // attach it to vue
                    if(membersAsJson !== undefined) {
                        this.memberRecord = membersAsJson[0];
                        // create two values for the date fields day-month
                        let birthday = this.memberRecord.birth_date;
                        if(birthday.length === 4) {
                            this.memberRecord.birth_month = birthday.substr(0, 2);
                            this.memberRecord.birth_day = birthday.substr(2, 2);
                        }
                    }
                },
                getSaveMessages() {
                    this.saveMessageFail = saveMessageFail;
                    this.saveMessageOK = saveMessageOK;
                },
                checkNewPassword() {
                    this.messagepw = '';
                    let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
                    if(this.pw1 !== '') {
                        if (!strongRegex.test(this.pw1)) {
                            this.messagepw = 'nieuw wachtwoord is niet sterk genoeg';
                        } else if (this.pw1 !== this.pw2) {
                            this.messagepw = 'wachtwoord 2 is niet gelijk aan wachtwoord 1';
                        }
                    }
                }
            },
            watch: {
                memberRecord: {
                    handler(record) {
                        let dayValid = validDatepart(record.birth_day, "day");
                        let monthValid = validDatepart(record.birth_month, "month");
                        let yearValid = validDatepart(record.birth_year, "year");
                        this.messagedate =  (dayValid && monthValid && yearValid) ? '' : 'datum niet correct';
                    },
                    deep: true
                }
            }
        });
    }*/

    /**
     * Check part of a date to be possibly valid. empty value returns true;
     * @param value {int} datepart to check
     * @param partName {String} "day", "month" or "year"
     * @param defreturn {boolean} return value if value is empty
     * @returns {boolean}
     */
    const validDatepart = (value='', partName="day", defreturn=true) => {
        console.log(`validating`);
        let valueInt = parseInt(value);
        if(value === '') {
            return defreturn;
        }
        const currentYear = new Date().getFullYear();
        if (partName === "day") {
            return (!isNaN(value)) && valueInt > 0 && valueInt < 32;
        }
        if (partName === "month") {
            return (!isNaN(value)) && valueInt > 0 && valueInt < 13;
        }
        if (partName === "year") {
            return (!isNaN(value)) && valueInt > 1900 && valueInt <= currentYear;
        }
        return false;
    };

    /**
     * Find a GET parameter
     * @param parameterName {string} parameter to search for
     * @returns {string} returns null if the parameter was not found
     */
    function findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        console.log(`returning ${result}`);
        return result;
    }
});
